import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {GuestModal}     from "@Xpresso/routes/common/guest-modal/guest-modal";

export const SubscribeButton = ({subscriptionModal, planId}) => cs(
    consumeContext("userLevels"),
    ["guestModal", ({}, next) => GuestModal({
        content: "newAccount",
        next
    })],
    ({userLevels, guestModal}) => (
        <div className="actions">
            <button
                className="subscribe"
                disabled={planId == null && !userLevels.isGuest}
                onClick={() => userLevels.isGuest ? guestModal.show() : subscriptionModal.show({planId})}
                xd-qa-type="button"
                xd-qa-name="Subscribe"
            >
                SUBSCRIBE
            </button>
        </div>
    )
)